export default {
  serviceMenuOverview: "概要",
  serviceMenuPipeline: "パイプライン",
  serviceMenuAnalytics: "分析",
  serviceMenuResources: "リソース",
  salesServices: "セールスサービス",
  chooseYourTypeofServicesToStreamlineAndEnhanceYourBusinessOperations:
    "ビジネス運営を効率化し強化するために、サービスの種類を選択してください",
  dataPreparation: "データ準備",
  salesAssistant: "セールスアシスタント",
  appointmentSetting: "アポイントメント設定",
  othersCustomService: "その他（カスタムサービス）",
  requestService: "サービスをリクエスト",
  learnMore: "もっと詳しく",
  serviceRequestStatus: "サービスリクエスト状況",
  noServiceRequestsYet: "サービスリクエストはまだありません",
  submitYourFirstRequestToUnlockThePower:
    "最初のサービスリクエストを送信して、当社のセールスサービスの力を解き放ちましょう！こちらでリクエストの状況を追跡し、セールス活動を強化しましょう。さあ、始めましょう！",
  serviceTableItemName: "名前",
  serviceTableItemStatus: "ステータス",
  serviceTableItemType: "種類",
  serviceTableItemProgress: "進捗",
  serviceTableItemStart: "開始",
  serviceTableItemEnd: "終了",
  serviceTableItemPriority: "優先度",
  addASubject: "件名を追加",
  created: "作成済み",
  closed: "終了済み",
  paused: "一時停止中",
  working: "作業中",
  completed: "完了",
  resuming: "再開中",
  reviewing: "レビュー中",
  others: "その他",
  data_preparation: "データ準備",
  sales_assistant: "セールスアシスタント",
  appointment_setting: "アポイントメント設定",
  appointment_booking: "アポイントメント予約",
  low: "低",
  normal: "通常",
  urgent: "緊急",
  high: "高",
  requiredCredits: "必要なクレジット",
  serviceCreated: "作成済み",
  QandARecord: "Q&A記録",
  serviceAttachments: "添付ファイル",
  discussionBoard: "ディスカッションボード",
  wannaAddSomething: "何か追加しますか？",
  serviceEdit: "編集",
  serviceDelete: "削除",
  addDescription: "説明を追加",
  DragDropor: "ドラッグ＆ドロップまたは",
  chooseFile: "ファイルを選択",
  toUpload: "してアップロード",
  ourDataPreparationService:
    "当社のデータ準備サービスは、セールスデータ管理を最適化するための包括的なソリューションを提供します。お客様が既存のデータセットを強化し、データクレンジングによる正確性を確保し、ニーズに完全に合致するカスタムリストを作成することに焦点を当てています。このアプローチにより、データを効果的に管理するために必要な柔軟性と効率性を得ることができます。",
  moreoverWithOurDedicatedDataManagement:
    "さらに、専用のデータ管理サービスであるPubrioを利用することで、プロセスはさらに簡単になります。ファイルをシームレスに添付し、追加情報でデータセットを強化できます。Pubrioは、データの充実化だけでなく、特定の基準に基づいて全く新しいリストを作成することも可能です。このパーソナライズされたサービスにより、データセットがお客様の目的と業界標準に合わせて正確に調整され、データランドスケープを自由にコントロールできるようになります。",
  flexibilityToAttach:
    "既存のリストを添付するか、指定された基準に基づいて新しいリストをPubrioに作成させる柔軟性。",
  comprehensiveDataEnrichment:
    "不足している詳細を追加し、データセットの完全性を高めるための包括的なデータエンリッチメント。",
  dataCleansingServicesToEnsureAccuracy:
    "重複の削除やエラー修正など、正確性と品質を確保するためのデータクレンジングサービス。",
  abilityToInstructPubrio:
    "細かく定義された基準に基づいて、全く新しいリストをPubrioにキュレーションさせる機能。",
  tailoringDatasetsPrecisely:
    "特定の目標や業界標準に合わせてデータセットを正確に調整。",
  dataEnrichmentWithExistingList:
    "既存リストのデータエンリッチメント：既存のリストをPubrioにアップロードして簡単に強化します。Eメールアドレスや電話番号などの不足している詳細情報を、お客様の要件に合わせて補完します。たとえば、顧客データベースを提供していただければ、必要な情報で更新します。",
  customListGenerationIf:
    "カスタムリスト生成：リストがない場合は、Pubrioがお客様のために作成します。役職や産業などの基準をお知らせいただければ、最適なリストを作成します。例えば、特定の地域のトップテクノロジー役員のリストが必要な場合、当社が対応します。",
  dataCleansingForExistingLists:
    "既存リストのデータクレンジング：Pubrioのデータクレンジングサービスでデータの正確性と信頼性を確保します。リストをお送りいただければ、重複を削除し、エラーを修正します。たとえば、最近のリードリストをお持ちの場合、マーケティングキャンペーンに使えるように準備します。",
  empoweringYourSalesEeavors:
    "セールス活動を強化するため、当社のセールスアシスタントサービスは、さまざまな重要な分野で包括的なサポートを提供し、アウトリーチとコミュニケーション戦略が成功に向けて完璧に調整されるようにします。魅力的なコンテンツを作成したい、イベントをシームレスに整理したい、オーダーメイドのプレゼンテーションを開発したい、またはセールスおよびコミュニケーション戦略を洗練したいなど、お客様のセールス活動を強化し、市場でのブランドプレゼンスを高めるために、専任チームがお手伝いします。",
  craftingCompellingContent:
    "魅力的なコンテンツの作成：効果的なコミュニケーションは、オーディエンスの注意を引くための鍵です。当社のチームは、ブランドとオーディエンスの好みに合わせた魅力的なコンテンツの作成に優れています。示唆に富むLinkedInの投稿から、有益なブログ記事、目を引くソーシャルメディアの更新まで、お客様のメッセージがターゲット市場に響くようにします。",
  seamlessEventAndWebinarPreparation:
    "シームレスなイベントとウェビナーの準備：イベントとウェビナーは、オーディエンスと交流し、リードを生成するための強力なツールです。当社のセールスアシスタントサービスは、計画からプロモーション、実行まで、すべての詳細を管理します。有益なウェビナーを開催する場合でも、ネットワーキングイベントを企画する場合でも、イベントが永続的な印象を残すようにします。",
  tailoredContentDevelopmentAndPresentation:
    "オーダーメイドのコンテンツ開発とプレゼンテーション：魅力的なプレゼンテーションとパーソナライズされたメッセージでオーディエンスを魅了します。当社のチームは、視覚的に魅力的なデッキを作成し、特定のオーディエンスセグメントに響くオーダーメイドのメッセージを作成することを専門としています。投資家へのピッチやリードの育成など、お客様のコンテンツが際立つようにします。",
  strategicSalesAndCommunicationFrameworks:
    "戦略的なセールスおよびコミュニケーションフレームワーク：戦略的なガイダンスと効果的なコミュニケーションスクリプトでセールスプロセスを合理化します。当社のセールスアシスタントサービスは、コンバージョンを促進し、有意義なつながりを育むために必要なツールと戦略をお客様のチームに提供します。",
  craftingCompellingContent: "魅力的なコンテンツの作成",
  companyLinkedInPosts: "会社のLinkedIn投稿（頻度：毎週または毎月）",
  personalLinkedInPosts:
    "個人のLinkedIn投稿（頻度：柔軟、好みとコンテンツの利用可能性による）",
  websiteBlogPosts:
    "ウェブサイトブログ投稿（頻度：通常は毎週または隔週）",
  socialMediaPosts:
    "ソーシャルメディア投稿（頻度：毎日またはコンテンツ戦略による）",
  emailMarketingCampaigns:
    "Eメールマーケティングキャンペーン（頻度：毎週または隔週）",
  seamlessEventAndWebinarPreparation: "シームレスなイベントとウェビナーの準備",
  webinarAndWorkshopPreparation: "ウェビナーとワークショップの準備",
  networkingAndOfflineEvent: "ネットワーキングとオフラインイベントの調整",
  tailoredContentDevelopment: "オーダーメイドのコンテンツ開発とプレゼンテーション",
  companyDeckPreparation:
    "会社デッキの準備（プレゼンテーション、ピッチなど用）",
  highlyPersonalizedMessage:
    "高度にパーソナライズされたメッセージ作成（特定のオーディエンスセグメント向け）",
  strategicSales: "戦略的なセールスとコミュニケーションフレームワーク",
  salesCallScripts: "セールスコールスクリプト",
  emailOutreachTemplate: "Eメールアウトリーチテンプレート",
  salesChannelStrategies: "セールスチャネル戦略",
  ourAppointmentSettingService:
    "当社のアポイントメント設定サービスは、重要なつながりを促進し、業界での露出を育み、価値ある見込み客を育成することで、お客様のビジネスを高めるために調整されています。個別の業界露出、シームレスなセミナーおよびウェビナー調整、新規見込み客のウォームアップ、新しいオーディエンスへの魅力的なアプローチを開始することを専門としています。",
  individualIndustryAppointment:
    "個別の業界アポイントメント露出と反応",
  tailoredOutreach:
    "業界内の主要な意思決定者やインフルエンサーへのオーダーメイドのアウトリーチは、ターゲットを絞った露出を保証します。",
  strategicFollowups:
    "戦略的なフォローアップにより、反応を測定し、懸念事項に対処し、より深いエンゲージメントを育むことができます。",
  eachInteraction:
    "各インタラクションは、受信者のプロフィールと好みに基づいてパーソナライズされ、影響を最大化します。",
  seminarWebinarCoordination: "セミナー＆ウェビナー調整",
  ourExpertTeamHandles:
    "当社の専門チームは、初期計画からイベント後のフォローアップまで、セミナーとウェビナーの調整のあらゆる側面を処理します。",
  weMeticulouslyPlan:
    "お客様の専門知識を紹介するために、イベントを細心の注意を払って計画および実行し、参加者にとってシームレスで魅力的な体験を保証します。",
  byLeveragingAdvancedTechnologyPlatforms:
    "高度なテクノロジープラットフォームを活用することで、インタラクションと参加を強化し、イベントの影響を最大化します。",
  newProspectWarmUp: "新規見込み客のウォームアップ",
  proactiveEngagementStrategies:
    "新規見込み客をウォームアップするためのプロアクティブなエンゲージメント戦略が採用され、実りある議論の土台を築きます。",
  tailoredCommunicationStrategies:
    "お客様の提供物に対する親近感、信頼、関心を築くために、オーダーメイドのコミュニケーション戦略が展開されます。",
  throughStrategicNurturing:
    "戦略的な育成を通じて、見込み客をエンゲージさせ、コンバージョンに向けて準備を整え、成功したアポイントメントの可能性を高めます。",
  newAudienceApproach: "新しいオーディエンスへのアプローチ",
  weEmployInnovativeStrategies:
    "新しいオーディエンスに到達し、従来のチャネルを超えてビジネスの範囲を拡大するために、革新的な戦略を採用しています。",
  targetedOutreachCampaigns:
    "徹底的なオーディエンス調査とセグメンテーションに基づいて、ターゲットを絞ったアウトリーチキャンペーンが作成され、関連性と効果を確保します。",
  ourApproachIsContinuouslyOptimized:
    "当社のアプローチは、フィードバックと洞察に基づいて継続的に最適化され、新しいオーディエンスに到達し、エンゲージする上で時代の先を行くようにします。",
  individualIndustry: "個別の業界アポイントメント露出と反応",
  personalizedAppointmentSetting:
    "業界の利害関係者とのパーソナライズされたアポイントメント設定。",
  strategicFollowupCommunication:
    "さらなるエンゲージメントのための戦略的なフォローアップコミュニケーション。",
  comprehensivePlanning: "イベントの包括的な計画と実行。",
  utilizationOfAdvancedTechnologies:
    "インタラクションを強化するための高度なテクノロジーの活用。",
  newProspectWarmUp: "新規見込み客のウォームアップ",
  proactiveEngagementStrategy:
    "見込み客に合わせたプロアクティブなエンゲージメント戦略。",
  customizedCommunication: "関心を維持するためのカスタマイズされたコミュニケーション。",
  newAudienceApproach: "新しいオーディエンスへのアプローチ",
  innovativeOutreach:
    "新しいオーディエンス向けに設計された革新的なアウトリーチキャンペーン。",
  continuousRefinement: "フィードバックと洞察に基づく継続的な改善。",
  customService: "カスタムサービス",
  tailoredToMeet:
    "お客様固有のニーズを満たすように調整された当社のカスタムサービスは、幅広い要件に対応するための柔軟性と適応性を提供します。ウェビナー参加者の追跡、オフラインイベントのプロモーション、広告の強化、またはその他の専門的なタスクに関する支援を求めている場合でも、当社の専任チームがお客様の目標を効率的かつ効果的に達成するお手伝いをします。",
  webinarParticipantsTracking: "ウェビナー参加者追跡",
  comprehensiveTrackingOfWebinar:
    "ウェビナー参加者の包括的な追跡により、エンゲージメントレベルを分析し、貴重な洞察を収集します。",
  customizedReportsAndAnalytics:
    "ウェビナーの有効性を評価し、将来の戦略を最適化するためのカスタマイズされたレポートと分析。",
  seamlessIntegration:
    "合理化されたデータ管理とレポート作成のための、既存システムとのシームレスな統合。",
  offlineEventPromotion: "オフラインイベントプロモーション",
  strategicPlanning:
    "参加とエンゲージメントを最大化するための、オフラインイベントプロモーションキャンペーンの戦略的な計画と実行。",
  utilizationOfTargetedMarketingChannels:
    "ターゲットオーディエンスに効果的にリーチするための、ターゲットを絞ったマーケティングチャネルとプロモーション戦術の活用。",
  creativeApproaches:
    "各イベントのユニークな特性に合わせた創造的なアプローチにより、最大限の影響とROIを確保します。",
  adsEnhancement: "広告の強化",
  optimizationOfAdCampaigns:
    "可視性、エンゲージメント、コンバージョン率を高めるための、さまざまなプラットフォームでの広告キャンペーンの最適化。",
  ABTesting:
    "最も効果的な広告クリエイティブ、メッセージ、ターゲティング戦略を特定するためのA/Bテストとパフォーマンス分析。",
  continuousMonitoring:
    "変化する市場ダイナミクスに適応し、結果を最大化するための、広告キャンペーンの継続的な監視と調整。",
  customizedSolutions: "カスタマイズされたソリューション",
  ourCustomService:
    "当社のカスタムサービスは、事前に定義された機能を超えて、お客様の特定の要件と好みに対応します。",
  whetherYouNeedAssistance:
    "データ分析、コンテンツ作成、戦略的計画、またはビジネスのその他の側面に関する支援が必要な場合でも、お客様のニーズに合わせてサービスを調整できます。",
  ourFlexibleApproach:
    "当社の柔軟なアプローチにより、お客様と緊密に連携して、目に見える結果をもたらし、ビジネスの成長を促進するカスタマイズされたソリューションを開発できます。",
  setupAndImplementation:
    "ウェビナー参加者追跡システムのセットアップと実装。",
  customizedReporting:
    "ウェビナーのパフォーマンスとオーディエンスのエンゲージメントを測定するためのカスタマイズされたレポートと分析。",
  developmentAndExecution:
    "ターゲットを絞ったオフラインイベントプロモーションキャンペーンの開発と実行。",
  coordinationOfPromotionalActivities:
    "印刷物、ダイレクトメール、ローカル広告を含むプロモーション活動の調整。",
  evaluationAndOptimization:
    "デジタルプラットフォーム全体での広告キャンペーンの評価と最適化。",
  creativeDevelopment:
    "ROIを最大化するためのクリエイティブ開発、ターゲティングの洗練、パフォーマンス監視。",
  tailoredServices:
    "特定のニーズと目標に対応するオーダーメイドのサービス。",
  collaborationWithOurTeam:
    "お客様固有の要件を満たすカスタマイズされたソリューションを開発するための、当社のチームとの連携。",
  serviceGetStarted: "開始",
  keyFeatures: "主な機能",
  dataEnrichment: "データエンリッチメント",
  dataCleansing: "データクレンジング",
  customListGeneration: "カスタムリスト生成",
  serviceOfferings: "サービス内容",
  introDataPreparation:
    "当社のデータ準備サービスは、セールスデータ管理を最適化するための包括的なソリューションを提供します。...",
  introSalesAssitant:
    "セールスアシスタントサービスは、一般的な管理サポートを超え、セールスプロセスに不可欠なタスクに特化しています。...",
  introAppointmentSetting:
    "このサービスは、提供された情報に基づいて顧客とターゲットオーディエンスを結びつける、パーソナライズされた実践的なアプローチを含みます。...",
  introOtherService:
    '「その他」サービスは、顧客が独自のニーズに関する詳細を提出してカスタムサービスをリクエストできるサービスです。...',
  questionCommonPagePriorityLevelTitle:
    "このタスクの優先度レベルは？",
  questionCommonPagePriorityLevelDesc:
    "タスクの優先度を明記することで、お客様のニーズに迅速に対応できます。送信後でも変更可能です。",
  questionCommonPageTimelineTitle:
    "サブスクリプション期間またはタイムラインについて考えはありますか？",
  questionCommonPageTimelineDesc:
    "ご希望の期間と開始予定をお知らせください。",
  questionCommonPageServiceRequestTitle:
    "準備はできましたか？まず、アプリケーションに独自の名前を付けてください",
  questionCommonPageServiceRequestDesc:
    "この名前を使用して、ダッシュボードで進捗状況を追跡し、更新情報をお知らせします。",
  questionCommonPageServiceDurationTitle:
    "サービス期間はどのくらいですか？",
  quesitonCommonPageInvestmentBudget:
    "ビジネス開発およびプロジェクトへの投資予算は、月額12,000香港ドルを超えますか？",
  questionCommonPageHearAboutUs: "どちらで当社のことを知りましたか？",
  questionCommonPageUploadTitle:
    "データエンリッチメントまたはデータクレンジングのために、Excel/CSVファイルをここにアップロードしてください",
  questionCommonPageUploadDesc:
    "カスタムリスト生成を選択する場合は、アップロードせずにスキップまたは「次へ」をクリックできます",
  questionDataPreparationPageInterestedDataOptimizationTitle:
    "データ最適化に関して、どのサービスにご興味がありますか？",
  questionDataPreparationPageInterestedDataOptimizationDesc:
    "データエンリッチメントまたはデータクレンジングを選択する場合、次のステップでCSVファイルを添付する必要があります",
  questionDataPreparationPageDataAttributesTitle:
    "ファイルに組み込みたい特定のデータ属性を選択してください（該当する場合）",
  questionDataPreparationPageDataAttributesDesc: "1つ以上選択してください",
  questionDataPreparationPageNumberOfLeadsTitle:
    "ビジネスのためにどれくらいのリードを生成または獲得したいですか？",
  questionDataPreparationPageNumberOfLeadsDesc:
    "数量または範囲を指定して、お客様に合わせたサービスを提供します",
  website_url: "ウェブサイトURL",
  contact_first_name: "連絡先 姓",
  contact_last_name: "連絡先 名",
  contact_title: "連絡先 役職",
  contact_location: "連絡先 所在地",
  contact_work_email: "連絡先 勤務先Eメール",
  contact_personal_email: "連絡先 個人Eメール",
  contact_work_phone: "連絡先 勤務先電話番号",
  contact_personal_phone: "連絡先 個人電話番号",
  company_size: "会社規模",
  company_industry: "会社産業",
  company_location: "会社所在地",
  company_founded_year: "会社設立年",
  company_keywords: "会社キーワード",
  company_ranking_in_global: "世界ランキング",
  company_financial_status: "会社の財務状況",
  company_office_address: "会社のオフィス住所",
  website_total_visit: "ウェブサイト総訪問数",
  company_funding_status: "会社の資金調達状況",
  slugServiceName: "サービス名",
  slugServiceDesc: "サービス説明",
  errEnterServiceName: "サービス名を入力してください",
  errEnterDescription: "サービス説明を入力してください",
  errSelectAService: "サービスを選択してください",
  errSelectSpecificDataAttributes: "特定のデータ属性を選択してください",
  errInputTheQuantity: "数量を入力してください",
  errSelectPriorityLevel: "優先度レベルを選択してください",
  errSelectTimeline: "タイムラインを選択してください",
  errInputContent: "内容を入力してください",
  errInvestmentBudget: "「はい」または「いいえ」を選択してください",
  errServiceDuration: "サービス期間を選択してください",
  errHearAboutUs: "内容を選択してください",
  placeHolderEnterServiceName: "サービス名を入力",
  placeHolderEnterServiceDescription: "サービス説明を入力",
  placeHolderEnterListGeneration: "リスト生成を入力",
  placeHolder150TO250: "150 - 250",
  Submit: "送信",
  serviceDownload: "ダウンロード",
  serviceExample: "例",
  forYourReference: "ご参考までに",
  yourFileNeedsToInclude:
    "ファイルには少なくともウェブサイトまたは会社名を含める必要があります",
  includeAll: "すべて含める",
  serviceNext: "次へ",
  serviceBack: "戻る",
  data_enrichment: "データエンリッチメント",
  data_cleansing: "データクレンジング",
  custom_list_generation: "カスタムリスト生成",
  job_title: "役職",
  timeline_within_one_weeks: "1週間以内",
  timeline_one_to_two_weeks: "1〜2週間",
  timeline_two_to_four_weeks: "2〜4週間",
  timeline_recurring: "定期的",
  timeline_custom_range: "カスタム範囲",
  hear_about_us_social_media: "ソーシャルメディア",
  hear_about_us_google: "Google",
  hear_about_us_online_article: "オンライン記事",
  hear_about_us_webinar: "ウェビナー",
  hear_about_us_referral: "紹介",
  hear_about_us_custom_input: "その他",
  duration_last_than_one_month: "1ヶ月未満",
  duration_one_to_three_months: "1〜3ヶ月",
  duration_over_three_months: "3ヶ月以上",
  duration_decide_later: "後で決める",
  yes: "はい",
  no: "いいえ",
  byCancelingYouCanEnsureThatNoTasksWillBeClosed:
    "キャンセルすると、タスクは閉じられません",
  areYouSureYouWantToCloseThisTask: "このタスクを閉じてもよろしいですか？",
  onceTheTaskIsClosed:
    "タスクが閉じられると元に戻すことはできず、再開することもできません",
  Close: "閉じる",
  ourTeamIsWorkingOnThisTask: "私たちのチームがこのタスクに取り組んでいます",
  pleaseProviceYourReasonForThisAction:
    "この操作の理由を教えてください",
  sendRequest: "リクエストを送信",
  OK: "OK",
  areYouSureYouWantToDelete: "削除してもよろしいですか？",
  proceedingWithDeletionWillResultInPermanentRemovalOfTheFile:
    "削除を続行すると、ファイルは完全に削除されます。",
  byCancelYouEnsureThatNoFileWillBeDeleted:
    "キャンセルすると、ファイルは削除されません",
  areYouSureYouWantToDeleteThis: "これを削除してもよろしいですか？",
  serviceMessage: "メッセージ",
  serviceFile: "ファイル",
  proceedingWithDeletionWillResultInPermanentRemovalOfThisMessage:
    "削除を続行すると、このメッセージは完全に削除されます。",
  proceedingWithDeletionWillResultInPermanentRemovalOfThisFile:
    "削除を続行すると、このファイルは完全に削除されます。",
  youEnsureThatNoMessagesWillBeDeleted:
    "キャンセルすると、メッセージは削除されません",
  youEnsureThatNoFilessWillBeDeleted:
    "キャンセルすると、ファイルは削除されません",
  serviceDeleteFail: "削除失敗",
  enterYourReason: "理由を入力してください",
  seriveStartDate: "開始日",
  serviceEndDate: "終了日",
  yourRequestHasBeenSent: "リクエストが送信されました",
  sendUsYourFeedback: "フィードバックをお寄せください",
  weAreConstantlyImproving:
    "私たちは常に改善を続けています！フィードバックを共有して、当社のプラットフォームの未来を形作ってください。",
  describeYourExperienceHere: "ここでのご経験についてご説明ください...",
  additionallyYouCanAttachAnyScreenshots:
    "さらに、詳細を提供するためにスクリーンショットやファイルを添付することもできます。",
  sendFeedback: "フィードバックを送信",
  serviceResume: "再開",
  yourRequestHasBeenResumed: "リクエストが再開されました",
  yourRequestIsCurrentlyPaused: "リクエストは現在一時停止中です",
  serviceEdited: "編集済み",
  theFileSizeCannotExceed50M: "ファイルサイズは50Mを超えられません",
};